import { render, staticRenderFns } from "./os-application-picker.vue?vue&type=template&id=3963dd62&"
import script from "./os-application-picker.vue?vue&type=script&lang=js&"
export * from "./os-application-picker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports